import createSvgIcon from '../Utils/CreateSvgIcon';

//THIS IS A TEMP ICON THAT CAN BE USED ON WHITE BACKGROUNDS - DESIGN TEAM TO PROVIDE FINAL ICON
export const Notification = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0525 11.1666V15.6312L18 19H10.4142L10.7071 19.2929C11.0976 19.6834 11.0976 20.3166 10.7071 20.7071C10.3166 21.0976 9.68342 21.0976 9.29289 20.7071L7.58579 19H0L0.947266 15.6319V10.1111H0.961019C1.20241 6.20655 4.60388 3.09756 8.80139 3.00225C8.44034 3.62703 8.18868 4.32295 8.0726 5.06384C5.20398 5.46393 3.11444 7.6913 2.95721 10.2345L2.94727 10.3953V15.9078L2.6401 17H15.3599L15.0525 15.9071V11.908C15.7715 11.7808 16.4463 11.5255 17.0525 11.1666Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 7H18V5H15L15 2H13L13 5L10 5V7L13 7V10H15L15 7Z"
    />
  </>,
  'Notification',
);
